<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">接收方</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>VIP：</label>
          <el-select v-model="vipState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in vipStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <el-select v-model="timeType" placeholder="Select" style="width: 7.6em; margin-right: 4px;">
            <el-option v-for="item in timeTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <DatePickerRange title="" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <!--          <el-button type="primary" v-loading="updateLoading" @click="updateInteract">标为已审查</el-button>-->
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
            @sort-change="sortChange"
        >
          <!--          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>-->
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="106">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="互动发起方" v-if="checkColList.indexOf('互动发起方') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth"/>
            </template>
          </el-table-column>
          <el-table-column property="" label="发起方相关时间" v-if="checkColList.indexOf('发起方相关时间') > -1" width="160">
            <template #default="scope">
              <p>注册时间<br/>{{scope.row.regTime}}</p>
              <p style="margin: 8px 0;">进入应用时间<br/>{{scope.row.enterTime}}</p>
              <p>信息首次提交时间<br/>{{scope.row.firstSubmitTime}}</p>
              <p style="margin: 8px 0;">信息首次通过时间<br/>{{scope.row.firstPassTime}}</p>
              <p>最新登录时间<br/>{{scope.row.loginTime}}</p>
            </template>
          </el-table-column>
          <el-table-column property="enterMoney" label="认证费" v-if="checkColList.indexOf('认证费') > -1" width="80"/>
          <el-table-column property="enterBao" label="保证金" v-if="checkColList.indexOf('保证金') > -1" width="80"/>
          <el-table-column property="msgViolationNum" label="今天/昨天/前天/总共(接收招呼)" v-if="checkColList.indexOf('今天/昨天/前天/总共(接收招呼)') > -1" class-name="cursor">
            <template #default="scope">
              <span style="color: #409eff">
                {{
                  (scope.row.greetingNum.todayNum?scope.row.greetingNum.todayNum:0) + ' / ' +
                  (scope.row.greetingNum.yesterdayNum?scope.row.greetingNum.yesterdayNum:0) + ' / ' +
                  (scope.row.greetingNum.beforeYesterdayNum?scope.row.greetingNum.beforeYesterdayNum:0) + ' / ' +
                  (scope.row.greetingNum.totalNum?scope.row.greetingNum.totalNum:0)
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column property="msgViolationNum" label="今天/昨天/前天/总共(被心动)" v-if="checkColList.indexOf('今天/昨天/前天/总共(被心动)') > -1" class-name="cursor">
            <template #default="scope">
              <span style="color: #409eff">
                {{
                  (scope.row.userLoveNum.todayNum?scope.row.userLoveNum.todayNum:0) + ' / ' +
                  (scope.row.userLoveNum.yesterdayNum?scope.row.userLoveNum.yesterdayNum:0) + ' / ' +
                  (scope.row.userLoveNum.beforeYesterdayNum?scope.row.userLoveNum.beforeYesterdayNum:0) + ' / ' +
                  (scope.row.userLoveNum.totalNum?scope.row.userLoveNum.totalNum:0)
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column property="msgViolationNum" label="今天/昨天/前天/总共(来访)" v-if="checkColList.indexOf('今天/昨天/前天/总共(来访)') > -1" class-name="cursor">
            <template #default="scope">
              <span style="color: #409eff">
                {{
                  (scope.row.userVisitNum.todayNum?scope.row.userVisitNum.todayNum:0) + ' / ' +
                  (scope.row.userVisitNum.yesterdayNum?scope.row.userVisitNum.yesterdayNum:0) + ' / ' +
                  (scope.row.userVisitNum.beforeYesterdayNum?scope.row.userVisitNum.beforeYesterdayNum:0) + ' / ' +
                  (scope.row.userVisitNum.totalNum?scope.row.userVisitNum.totalNum:0)
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column property="" label="vip记录" v-if="checkColList.indexOf('vip记录') > -1" class-name="cursor">
            <template #default="scope">
<!--              <div v-for="(item, index) in scope.row.vipDtList" :key="index" style="margin: 8px 0;">-->
<!--                <p>{{item.createTime}}</p>-->
<!--                <p>{{item.vipRecord}}</p>-->
<!--              </div>-->
              <UserVipLog :user-log-list="scope.row.vipDtList" />
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="180">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex; margin-top: 16px; justify-content: space-between; align-items: flex-start">
          <el-table
              ref="multipleTableRef"
              :data="dataSummary"
              style="width: 50%"
              border
              v-loading="summaryLoading"
          >
            <el-table-column property="label" label="全平台汇总" />
            <el-table-column property="greetingNum" label="接收招呼" />
            <el-table-column property="userLoveNum" label="被心动" />
            <el-table-column property="userVisitNum" label="来访" />
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import { getReceiverPageList, getReceiverPageSummary } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import ipCityAbnormalDialog from '@/components/resume/ipCityAbnormalDialog'
import GreetingDateNum from "@/views/greeting/components/GreetingDateNum";
import UserLoveDateNum from "@/views/greeting/components/UserLoveDateNum";
import UserVisitDateNum from "@/views/greeting/components/UserVisitDateNum";
import UserVipLog from "@/components/VipLog/UserVipLog";
import UserVipLogDialog from "@/components/VipLog/UserVipLogDialog";

export default {
  name: "GreetingInitiator",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog, UserVipLog },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      vipStateArray: [
        {label: '不限', value: -1},
        {label: '未开通', value: 1},
        {label: '未过期', value: 2},
        {label: '已过期', value: 3},
      ],
      vipState: -1,

      timeTypeArray: [
        {label: '进入时间', value: 1},
        {label: '注册时间', value: 2},
        {label: '登陆时间', value: 3},
      ],
      timeType: 1,

      //注册/进入时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['头像', '互动发起方', '发起方相关时间', '认证费', '保证金', '今天/昨天/前天/总共(接收招呼)', '今天/昨天/前天/总共(被心动)', '今天/昨天/前天/总共(来访)', 'vip记录', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],
      summaryLoading: false,

      idArray: [],
      updateLoading: false,

      limitState: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.vipState = -1;
      this.timeType = 1;
      this.searchValue = '';
      this.limitState = false;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //排序
    sortChange(column) {
      if(column.prop == 'chatTime') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'chatNum') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      }
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
        this.getPageSummary()
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['vipState'] = this.vipState;
      param['timeType'] = this.timeType;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getReceiverPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //vip记录
      if(column.label == 'vip记录') {
        Dialog.open({
          title: 'vip记录',
          component: UserVipLogDialog,
          data: {
            id: row.userId
          },
          close: () => {

          }
        })
      }

      if(column.label == '今天/昨天/前天/总共(接收招呼)') {
        Dialog.open({
          title: '用户接收招呼数量列表',
          component: GreetingDateNum,
          data: {
            userId: row.userId,
            type: 2,
            width: '600px'
          },
          close: () => {

          }
        })
      }

      if(column.label == '今天/昨天/前天/总共(被心动)') {
        Dialog.open({
          title: '用户被心动数量列表',
          component: UserLoveDateNum,
          data: {
            userId: row.userId,
            width: '600px'
          },
          close: () => {

          }
        })
      }

      if(column.label == '今天/昨天/前天/总共(来访)') {
        Dialog.open({
          title: '用户来访数量列表',
          component: UserVisitDateNum,
          data: {
            userId: row.userId,
            type: 2,
            width: '600px'
          },
          close: () => {

          }
        })
      }

    },

    //用户异常ip列表
    openIpCityDialog(idx, row) {
      Dialog.open({
        title: '用户【' + row.nickName + '】异常ip列表',
        component: ipCityAbnormalDialog,
        data: {
          id: row.userId,
          width: '600px',
          ipState: row.ipState,
        },
        confirm: (result) => {
          this.pageDataList[idx]['ipState'] = result.state
        }
      })
    },


    getPageSummary() {
      this.summaryLoading = true;
      getFormData(getReceiverPageSummary).then(data => {
        let {msg, code } = data;
        if(code == 200) {
          let list = data['data'];
          this.dataSummary = [];
          let obj_1 = {
            label: '今天',
            greetingNum: list.greetingNum?list.greetingNum.todayNum:0,
            userLoveNum: list.userLoveNum?list.userLoveNum.todayNum:0,
            userVisitNum: list.userVisitNum?list.userVisitNum.todayNum:0,
          }
          let obj_2 = {
            label: '昨天',
            greetingNum: list.greetingNum?list.greetingNum.yesterdayNum:0,
            userLoveNum: list.userLoveNum?list.userLoveNum.yesterdayNum:0,
            userVisitNum: list.userVisitNum?list.userVisitNum.yesterdayNum:0,
          }
          let obj_3 = {
            label: '前天',
            greetingNum: list.greetingNum?list.greetingNum.beforeYesterdayNum:0,
            userLoveNum: list.userLoveNum?list.userLoveNum.beforeYesterdayNum:0,
            userVisitNum: list.userVisitNum?list.userVisitNum.beforeYesterdayNum:0,
          }
          this.dataSummary = [obj_1, obj_2, obj_3]
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.summaryLoading = false;
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
